import type { ClassTimes } from '@/types';

export const WEEK_DAYS = ['월', '화', '수', '목', '금', '토', '일'];

export interface ClassTimeSource {
  class_times?: ClassTimes | null;
  class_start_time?: string | null;
  class_end_time?: string | null;
}

export interface DayTime {
  day: string;
  start: string;
  end: string;
}

/** 특정 요일의 수업 시간을 가져와요. 요일별 시간이 없으면 기존 대표 시간으로 대체해요. */
export function getDayTime(
  student: ClassTimeSource,
  day: string,
  fallbackStart?: string | null,
  fallbackEnd?: string | null,
): { start: string; end: string } {
  const t = student.class_times?.[day];
  if (t && (t.start || t.end)) {
    return { start: t.start || '', end: t.end || '' };
  }
  return {
    start: fallbackStart ?? student.class_start_time ?? '',
    end: fallbackEnd ?? student.class_end_time ?? '',
  };
}

/** 수업 요일 순서대로 요일별 시간 목록을 만들어요. */
export function listDayTimes(student: ClassTimeSource, days: string[]): DayTime[] {
  return WEEK_DAYS.filter((d) => days.includes(d)).map((d) => ({
    day: d,
    ...getDayTime(student, d),
  }));
}

/** 특정 요일 수업 시작 시간(정렬용). 없으면 '99:99'. */
export function dayStartKey(student: ClassTimeSource, day: string): string {
  return getDayTime(student, day).start || '99:99';
}

/** 카드에 표시할 요일별 시간 요약 문자열 목록. */
export function dayTimeLabels(student: ClassTimeSource, days: string[]): string[] {
  return listDayTimes(student, days)
    .filter((t) => t.start)
    .map((t) => `${t.day} ${t.start}${t.end ? `~${t.end}` : ''}`);
}